import React, { useEffect, useState } from "react";
import {
  createClient,
  createMicrophoneAndCameraTracks,
  createScreenVideoTrack,
} from "agora-rtc-react";
import AgoraRTC from "agora-rtc-sdk-ng";
import axios from "axios";
import { URL_API } from "../init/url";
import { APP_ID_AGORA } from "./constants";

// Dokumetasi Custom Hook Reactjs
//    Parameter: channelName:String, uid:Number
// Return Method or value:
//    - isJoin(): return (true/false)
//    - setJoin():(true/false)
//    - isConnect :return (true/false)
//    - usersJoin:[{uid:number, video:boolena, audio:bolean, agoraDetail:}]
//    - selfTracks: return ([0: audio], [1: video])
//    - isSelfTracksReady:return (true/false)
//    - setMuteSelfTracks():(type (string: audio / video), val (boolean))
//    - setShareScreen():(true/false)
// 	      - true, untuk mengatifkan sharescreen
// 	      - false, untuk menonaktifkan sharescreen
//    - isShareScreen: return (true/false),
// 	      - true, untuk bergabung dengan channel
// 	      - false, untuk menginggalkan channel

// const appId = "3f62b42cfd574fa38768ec2b3a8e281c";
// const appId = "9af3e01fb5e044528f6577ba5072edee";
const appId = APP_ID_AGORA;

const config = {
  mode: "rtc",
  codec: "vp8",
};

const useClient = createClient(config);
const useMicrophoneAndCameraTracks = createMicrophoneAndCameraTracks();

const useVideoClient = createClient(config);
// get Token from server

// manage error message

const errorCode = (number) => {
  var time = new Date();

  switch (number) {
    case 200:
      // Duplicat Uid
      return null;
    case 602:
      // Duplicat Uid
      return { code: number, text: "Access is terminated", timing: time };
    case 301:
      return {
        code: number,
        text: "Network is unstable, Trying to reconnect",
        timing: time,
      };
    case 401:
      return {
        code: number,
        text: "Please allow camera and audio permission",
        timing: time,
      };
    case 402:
      return {
        code: number,
        text: "Cancel to SHare screen",
        timing: time,
      };
    case 601:
      return { code: number, text: "Uid alrady use", timing: time };
    default:
      return { code: number, text: "Undefined", timing: time };
  }
};

const audioUsersVolume = (client) => {
  client.enableAudioVolumeIndicator();
  client.on("volume-indicator", (volumes) => {
    let tmp = [];
    volumes.forEach((volume) => {
      // console.log(`UID ${volume.uid} Level ${volume.level}`, volume);
      if (volume.uid && volume.level > 5) {
        tmp.push(volume);
      }
      //  else if (options.uid == volume.uid && volume.level < 5) {
      // }
    });
    console.log("UID sound", tmp);
    // listUserVolume = tmp;
    return tmp;
  });
};

// registeredUsers{ name, email, uid, type}
// reacthook custom function
// return
export default function useCoreAgoraRecording(props) {
  const { channelName, uid, token } = props;
  const [isConnect, setIsConnect] = useState(false);
  const [joinChannel, setJoinChannel] = useState(null);
  const [usersJoin, setUsersJoin] = useState([]);
  const [errorInfo, setErrorInfo] = useState(null);

  const [listUserVolume, setListUserVolume] = useState([]);

  const client = useClient();
  const { ready, tracks, error } = useMicrophoneAndCameraTracks();
  const mediaSelfError = error;
  // const localScreen = useScreenVideoTracks();
  const [isMuteTrackSelf, setIsMuteTrackSelf] = useState({
    video: true,
    audio: true,
  });

  useEffect(() => {
    let init = async (name) => {
      client.on(
        "connection-state-change",
        async (curState, revState, reason) => {
          console.log("1-test user joined", curState, revState, reason);
          let err = null;
          if (curState == "DISCONNECTED" && reason != "ID_BANNED") {
            err = errorCode(602);
          }
          if (curState == "RECONNECTING") {
            err = errorCode(301);
          }
          if (curState == "CONNECTED") {
            err = errorCode(200);
          }
          setErrorInfo(err);
        }
      );
      client.on("user-joined", async (user) => {
        setUsersJoin((prevUsers) => {
          return [...prevUsers, { uid: user.uid }];
        });
      });
      client.on("user-published", async (user, mediaType) => {
        await client.subscribe(user, mediaType);
        console.log("1-test subscribe success", user, mediaType);
        if (mediaType === "video") {
          setUsersJoin((prevUsers) => {
            let nextVal = prevUsers.map((x) => {
              if (x.uid == user.uid) {
                x.video = true;
                x.agoraDetail = user;
              }
              return x;
            });
            return nextVal;
          });
        }
        if (mediaType === "audio") {
          setUsersJoin((prevUsers) => {
            let nextVal = prevUsers.map((x) => {
              if (x.uid == user.uid) {
                x.audio = true;
                x.agoraDetail = user;
              }
              return x;
            });
            return nextVal;
          });
          user.audioTrack?.play();
        }
      });

      client.on("user-unpublished", (user, type) => {
        console.log("1-test unpublished", user, type);
        if (type === "audio") {
          setUsersJoin((prevUsers) => {
            let nextVal = prevUsers.map((x) => {
              if (x.uid == user.uid) {
                x.audio = false;
                x.agoraDetail = user;
              }
              return x;
            });
            return nextVal;
          });

          user.audioTrack?.stop();
        }
        if (type === "video") {
          setUsersJoin((prevUsers) => {
            let nextVal = prevUsers.map((x) => {
              if (x.uid == user.uid) {
                x.video = false;
                x.agoraDetail = user;
              }
              return x;
            });
            return nextVal;
          });
        }
      });

      client.on("user-left", (user) => {
        console.log("1-test leaving", user);
        // setUsers((prevUsers) => {
        //   return prevUsers.filter((User) => User.uid !== user.uid);
        // });
        setUsersJoin((prevUsers) => {
          return prevUsers.filter((User) => User.uid !== user.uid);
        });
      });

      client.on("published-user-list", (user) => {
        console.log("1-test user list published-user-list", user);
      });

      client.on("volume-indicator", (volumes) => {
        let tmp = [];
        volumes.forEach((volume) => {
          console.log(`UID sound ${volume.uid} Level ${volume.level}`, volume);
          if (volume.uid && volume.level > 30) {
            tmp.push(volume);
          }
        });
        setListUserVolume(tmp);
        // console.log("UID sound", tmp, tmp.length, listUserVolume);
      });

      await client.join(appId, name, token, uid);
      if (tracks) await client.publish([tracks[0], tracks[1]]);
      setIsConnect(true);
      setMuteSelfTracks("audio", false);
      setMuteSelfTracks("video", false);
      client.enableAudioVolumeIndicator();
    };

    if (ready && tracks && token != null && joinChannel) {
      console.log("agora use core set connected true");
      init(channelName);
    }
    if (mediaSelfError != null) {
      console.log("error permision camera and audio", mediaSelfError);
      setErrorInfo(errorCode(401));
    }
    console.log(
      "agora use core set connected true",
      ready,
      tracks,
      token,
      joinChannel,
      "==",
      ready && tracks && token != null && joinChannel
    );
  }, [channelName, client, ready, tracks, token, joinChannel]);

  const setJoin = async (val) => {
    if (val == false) {
      await client.leave();
      client.removeAllListeners();
      // we close the tracks to perform cleanup
      tracks[0].close();
      tracks[1].close();
      setIsConnect(false);
    }
    setJoinChannel(val);
  };

  const setMuteSelfTracks = async (type, val) => {
    if (type === "audio") {
      tracks[0].setEnabled(val);
      setIsMuteTrackSelf((ps) => {
        return { ...ps, audio: !ps.audio };
      });
    } else if (type === "video") {
      tracks[1].setEnabled(val);
      setIsMuteTrackSelf((ps) => {
        return { ...ps, video: !ps.video };
      });
    }
  };

  console.log("agora use core", {
    usersJoin,
    isConnect,
    errorInfo,
  });
  return {
    usersJoin,
    usersVolume: listUserVolume,
    setJoin,
    isConnect,
    errorInfo,
    stats: client?.getSessionStats,
  };
}
